export const PERIOD_MAP: Record<string, string> = {
	YEARLY: 'years',
	MONTHLY: 'months',
	WEEKLY: 'weeks',
	DAILY: 'days',
	HOURLY: 'hours',
};
